import React from 'react';
import LocnLogo from './LocnLogo.png'
import './LocnLayout.css'

const LocnLayout = ({children}) => {
    return (
        <>
        <header className="sticky top-0">
                <nav className="flex items-center justify-between flex-wrap bg-black p-2">
                    <div className="flex items-center flex-shrink-0 text-white mr-6">
                        <span className="font-semibold text-xl tracking-tight"><img src="/images/locn_logo.png" style={{ height: 60 }}/></span>
                    </div>
                    <div className="block lg:hidden">
                        <button className="flex items-center px-3 py-2 border rounded text-gray-200 border-gray-400 hover:text-white hover:border-white">
                        <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
                        </button>
                    </div>
                    <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
                        <div className="text-sm lg:flex-grow">

                        </div>
                        <div>
                        <a href="#" className="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 lg:mt-0">Log In</a>
                        </div>
                    </div>
                </nav>
        </header>
        <main className="p-0 relative">  
            <div className="mb-6">{children}</div>
        </main>
      </>
      );
}

export default LocnLayout;